import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { LazyImportWrapper } from 'components/foundation/LazyImportWrapper/LazyImportWrapper';
import { useOpenable } from 'hooks';
import useAutomaticBreaksEnabled from 'hooks/feature/automatic-breaks/useAutomaticBreaksEnabled/useAutomaticBreaksEnabled';
import { t } from 'i18next';
import React from 'react';
import { ClassName } from 'types/ClassName';
import IPosition from 'types/Position';
import { positionBreakSettingsFromString, positionBreakSettingsStatusString } from 'utils/positionBreakSettingsUtils';

const BreakModeForm = React.lazy(() => import('../forms/BreakModeForm'));

export const POSITION_BREAK_MODE_DETAIL_TITLE = t('Breaks');
export const POSITION_BREAK_MODE_DETAIL_DESCRIPTION = t(`Select how employees should track their breaks.`);

export interface IBreakModeDetailProps {
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
  className?: ClassName;
}

const BreakModeDetail = (props: IBreakModeDetailProps) => {
  const { position, onUpdate, editable, className } = props;
  const breakSettings = positionBreakSettingsFromString(position.breakSettings);
  const breakSettingsStatus = positionBreakSettingsStatusString(breakSettings);
  const enablePositionBreakSettingsFeature = useAutomaticBreaksEnabled();
  const dialog = useOpenable();

  if (!enablePositionBreakSettingsFeature) {
    return null;
  }

  function onSubmit() {
    dialog.close();
    onUpdate();
  }

  const classes = classNames('break-mode-detail', className);

  return (
    <>
      <ProDetailsItem
        title={POSITION_BREAK_MODE_DETAIL_TITLE}
        onClick={dialog.open}
        value={breakSettingsStatus}
        hint={POSITION_BREAK_MODE_DETAIL_DESCRIPTION}
        className={classes}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={dialog.isOpen} onClose={dialog.close}>
        <LazyImportWrapper triggerLoad={dialog.isOpen}>
          <BreakModeForm
            className="mt-4 p-8"
            onSubmit={onSubmit}
            positionId={position.id}
            currentSetting={breakSettings}
          />
        </LazyImportWrapper>
      </Dialog>
    </>
  );
};

export default BreakModeDetail;
